<template>
  <el-table-column
    prop="diff_accountant_deadline_date"
    sortable="custom"
    label="Eltérések könyvelésének határideje"
    show-overflow-tooltip
    min-width="290"
  >
    <template slot-scope="scope">
      {{ scope.row.diff_accountant_deadline_date | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'diff_accountant_deadline_date',
  };
</script>
